import { spaceCaseToCamelCase } from '@internal/helper'
import type { ButtonVariant } from '@satch-ui/components/button/types'

export const spaceCaseVariantToCamelCaseVariant = (
  spaceCaseVariant: ButtonVariant
) => spaceCaseToCamelCase(spaceCaseVariant)
